// Community Photos Redux Reducer
import {
    SHARE_PHOTO,
    UNSHARE_PHOTO,
    FETCH_COMMUNITY_GALLERY,
    INCREMENT_PHOTO_VIEW,
    SET_GALLERY_FILTERS,
    SET_SELECTED_PHOTO,
    SET_LIGHTBOX_OPEN,
} from './actions';

const initialState = {
    // Gallery data
    photos: [],
    totalCount: 0,
    currentPage: 1,
    pageSize: 24,
    totalPages: 0,

    // UI state
    filters: {
        page: 1,
        page_size: 24,
        featured: false,
        search: '',
        tags: '',
    },
    selectedPhoto: null,
    lightboxOpen: false,

    // Loading states
    loadingGallery: false,
    loadingShare: false,
    loadingUnshare: false,

    // Error states
    errorGallery: null,
    errorShare: null,
    errorUnshare: null,

    // Success messages
    shareMessage: null,
};

const communityReducer = (state = initialState, action) => {
    switch (action.type) {
        // ==================== SHARE PHOTO ====================
        case SHARE_PHOTO.REQUEST:
            return {
                ...state,
                loadingShare: true,
                errorShare: null,
                shareMessage: null,
            };

        case SHARE_PHOTO.SUCCESS:
            return {
                ...state,
                loadingShare: false,
                shareMessage: action.payload,
            };

        case SHARE_PHOTO.FAILURE:
            return {
                ...state,
                loadingShare: false,
                errorShare: action.payload,
            };

        // ==================== UNSHARE PHOTO ====================
        case UNSHARE_PHOTO.REQUEST:
            return {
                ...state,
                loadingUnshare: true,
                errorUnshare: null,
            };

        case UNSHARE_PHOTO.SUCCESS:
            return {
                ...state,
                loadingUnshare: false,
                // Remove photo from gallery if currently viewing it
                photos: state.photos.filter(photo => photo.id !== action.payload.archiveId),
            };

        case UNSHARE_PHOTO.FAILURE:
            return {
                ...state,
                loadingUnshare: false,
                errorUnshare: action.payload,
            };

        // ==================== FETCH GALLERY ====================
        case FETCH_COMMUNITY_GALLERY.REQUEST:
            return {
                ...state,
                loadingGallery: true,
                errorGallery: null,
            };

        case FETCH_COMMUNITY_GALLERY.SUCCESS:
            return {
                ...state,
                loadingGallery: false,
                photos: action.payload.results || [],
                totalCount: action.payload.count || 0,
                currentPage: action.payload.page || 1,
                pageSize: action.payload.page_size || 24,
                totalPages: action.payload.total_pages || 0,
            };

        case FETCH_COMMUNITY_GALLERY.FAILURE:
            return {
                ...state,
                loadingGallery: false,
                errorGallery: action.payload,
            };

        // ==================== INCREMENT VIEW ====================
        case INCREMENT_PHOTO_VIEW.REQUEST:
            return state; // No loading state for views to avoid UI flicker

        case INCREMENT_PHOTO_VIEW.SUCCESS:
            return {
                ...state,
                // Update view count for the photo
                photos: state.photos.map(photo =>
                    photo.id === action.payload.archiveId
                        ? { ...photo, views: action.payload.views }
                        : photo
                ),
                // Update selected photo if it matches
                selectedPhoto: state.selectedPhoto?.id === action.payload.archiveId
                    ? { ...state.selectedPhoto, views: action.payload.views }
                    : state.selectedPhoto,
            };

        case INCREMENT_PHOTO_VIEW.FAILURE:
            // Silently fail for view increments
            return state;

        // ==================== UI STATE ====================
        case SET_GALLERY_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload,
                },
            };

        case SET_SELECTED_PHOTO:
            return {
                ...state,
                selectedPhoto: action.payload,
            };

        case SET_LIGHTBOX_OPEN:
            return {
                ...state,
                lightboxOpen: action.payload,
                // Clear selected photo when closing lightbox
                selectedPhoto: action.payload ? state.selectedPhoto : null,
            };

        default:
            return state;
    }
};

export default communityReducer;
